import { TspType } from '@entities/tsp'

export const checkIsGameKey = (payee: { features?: { category_web?: string } }) =>
  Boolean(payee.features?.category_web?.split(', ').includes(TspType.KEYS))
